export const getImageUrl = (path) => {
  if (!path) return null;
  
  // If it's already a full Cloudinary URL, return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Fallback for old local paths (during migration period)
  const normalizedPath = path.replace(/\\/g, '/');
  const cleanPath = normalizedPath.startsWith('/') 
    ? normalizedPath.slice(1) 
    : normalizedPath;
  
  const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';
  return `${BASE_URL}/${cleanPath}`;
};